// extracted by mini-css-extract-plugin
export default {"divider":"style_divider__V0QJ1","announcement":"style_announcement__9G+ac"};